export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const PHONE_REGEX = /^\+?(?:[0-9][- ]?){6,14}[0-9]$/i;
